<template>
  <div id="newsdetails">
    <div class="news-bd" style="min-height: 350px;">
      <div class="top_back">
        <span @click="$router.back()">{{ $t('protocol.goBackLastPage') }}</span>
      </div>
      <div class="news-l 1">
        <div class="d_title">{{title}}</div>
        <div class="news-l-bd" v-html="info"></div>
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>
<script>

export default {
  name: "Protocol",
  data() {
    return {
      info: ""
    };
  },
  components: {
  },
  computed: {
    title() {
      if (this.$route.params.type == 1) {
        return this.$t('aboutUs.sectionRegistrationAgreement');
      } else if (this.$route.params.type == 2) {
        return this.$t('protocol.riskDisclosure');
      } else {
        return this.$t('protocol.instructionsUseFCC');
      }
    }
  },
  mounted() {
    let that = this;
    that
      .$http({
        url: "/app/Protocol/protocol",
        method: "post",
        data: {
          type: that.$route.params.type
        }
      })
      .then(function(res) {
        if (res.data.status == 200) {
          that.info = res.data.data.content;
        } else {
          that.$message.error(that.$t(res.data.msgId));
        }
      });
  },
  methods: {}
};
</script>
<style scoped>
@import url("./../assets/css/aboutus.css");
@import url("./../assets/css/news.css");
.top_back {
  width: 950px;
  margin: 0 auto;
  color: #333;
  padding: 30px 0 6px;
  /* font-size: 14px; */
}
.top_back span {
  cursor: pointer;
}
.news-l {
  float: none;
  display: block;
  margin: 0 auto;
  border: 1px solid #ccc;
  padding: 0 16px 20px;
}
.d_title {
  font-size: 24px;
  text-align: center;
  padding: 30px 0 30px;
}
</style>





// WEBPACK FOOTER //
// src/components/protocol.vue